<template>
    <!-- 发起提案 -->
    <div>
        <div class="header-section">
            <p class="title">Initiate proposal</p>
            <p class="sub-title">What is Initiate proposal?</p>
            <p class="content-text">You can post a new proposal here. We will review it and add it to the agenda after success</p>
        </div>

        <div class="main-content">
            <van-form ref='initProposalForm'>
                <!-- Proposer -->
                <div class="input-label" :class="{'input-label-highlight':proposerActive}">Proposer</div>
                <van-field
                        v-model="proposer"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter proposer' }]"
                        :class="{'input-highlight':proposerActive}"
                        @focus="proposalFocus"
                />
                <!-- Proposal headline -->
                <div class="input-label" :class="{'input-label-highlight':headlineActive}">Proposal headline</div>
                <van-field
                        v-model="headline"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter Proposal headline' }]"
                        :class="{'input-highlight':headlineActive}"
                        @focus="headlineFocus"
                />
                <!-- 多行文本 -->
                <div class="input-label" :class="{'input-label-highlight':introductionActive}">Introduction to the article</div>
                <van-field
                        v-model="introduction"
                        rows="4"
                        type="textarea"
                        input-class="textarea"
                        :autosize="{ maxHeight: 100, minHeight: 50 }"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter Introduction to the article' }]"
                        :class="{'input-highlight':introductionActive}"
                        @focus="introductionFocus"
                />
                <!-- Objective -->
                <div class="input-label" :class="{'input-label-highlight':objectiveActive}">Objective</div>
                <van-field
                        v-model="objective"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter Objective' }]"
                        :class="{'input-highlight':objectiveActive}"
                        @focus="objectiveFocus"
                />
                <!-- Plan -->
                <div class="input-label" :class="{'input-label-highlight':planActive}">Plan</div>
                <van-field
                        v-model="plan"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter Plan' }]"
                        :class="{'input-highlight':planActive}"
                        @focus="planFocus"
                />
                <!-- budget -->
                <div class="input-label" :class="{'input-label-highlight':budgetActive}">Budget</div>
                <van-field
                        v-model="budget"
                        error-message-align="right"
                        :rules="[{ required: true, message: 'Please enter budget' }]"
                        :class="{'input-highlight':budgetActive}"
                        @focus="budgetFocus"
                />
                <div class="btn-container">
                    <van-button block color="#4573E7" @click="submit">Submit</van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Form, Field, Button, Toast } from 'vant';
    Vue.use(Form).use(Field).use(Button).use(Toast);

    export default {
        data() {
            return {
                proposer: '',
                headline: '',
                introduction: '',
                objective: '',
                plan: '',
                budget: '',

                proposerActive: true,
                headlineActive: false,
                introductionActive: false,
                objectiveActive: false,
                planActive: false,
                budgetActive: false
            }
        },
        methods:{
            submit(values) {
                this.$refs.initProposalForm.validate().then(() => {
                    this.$toast.success('提交成功')
                    console.log('submit', values)
                }).catch(() => {
                    this.$toast.fail('提交失败')
                })
            },
            proposalFocus(){
                this.proposerActive = true;
                this.headlineActive = false;
                this.introductionActive = false;
                this.objectiveActive = false;
                this.planActive = false;
                this.budgetActive = false;
            },
            headlineFocus(){
                this.proposerActive = false;
                this.headlineActive = true;
                this.introductionActive = false;
                this.objectiveActive = false;
                this.planActive = false;
                this.budgetActive = false;
            },
            introductionFocus(){
                this.proposerActive = false;
                this.headlineActive = false;
                this.introductionActive = true;
                this.objectiveActive = false;
                this.planActive = false;
                this.budgetActive = false;
            },
            objectiveFocus(){
                this.proposerActive = false;
                this.headlineActive = false;
                this.introductionActive = false;
                this.objectiveActive = true;
                this.planActive = false;
                this.budgetActive = false;
            },
            planFocus(){
                this.proposerActive = false;
                this.headlineActive = false;
                this.introductionActive = false;
                this.objectiveActive = false;
                this.planActive = true;
                this.budgetActive = false;
            },
            budgetFocus(){
                this.proposerActive = false;
                this.headlineActive = false;
                this.introductionActive = false;
                this.objectiveActive = false;
                this.planActive = false;
                this.budgetActive = true;
            },
        }
    }
</script>

<style lang="less">
    .van-cell{
        padding:10px 50px;
        background-color: #F9F9F9;
    }
    .van-cell::after{
        border-bottom: none;
    }
    .van-field__control{
        padding:0 30px;
        height: 90px;
        color: #737373;
        border: 2px solid #C5D0DE;
        border-radius: 10px;
        background-color: #fff;
        font-size: 28px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 33px;
        letter-spacing: 1px;
        -webkit-background-clip: text;
    }
    .van-field__body{
        textarea{
            padding:30px;
        }
    }
    .van-field__error-message{
        margin-top:20px;
        height: 33px;
        color: #E10475;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 1px;
        -webkit-background-clip: text;
    }
    .input-label-highlight{
        color: #4573E7 !important;
    }
    .input-highlight{
        .van-field__control{
            color: #4573E7;
            border: 1px solid#4573E7;
        }
    }
</style>
<style lang="less" scoped>
    .header-section{
        overflow:hidden;
        margin: 110px 51px;
        text-align: center;
        .title{
            margin-top:120px;
            height: 83px;
            line-height: 83px;
            font-family: Poppins-Black, Poppins;
            font-size: 64px;
            font-weight: 900;
            color: #000000;
            -webkit-background-clip: text;
        }
        .sub-title{
            margin-top: 20px;
            height:45px;
            line-height: 35px;
            font-size: 30px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #000000;
            -webkit-background-clip: text;
        }
        .content-text{
            margin-top: 20px;
            height: 85px;
            line-height: 43px;
            font-size: 26px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #61666B;
            -webkit-background-clip: text;
        }
    }
    .main-content{
        overflow: hidden;
        background-color:#F9F9F9;
        .input-label{
            margin: 50px 50px 0;
            height: 39px;
            line-height: 33px;
            font-size: 28px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3A3F49;
            -webkit-background-clip: text;
        }
    }
    .btn-container{
        margin: 53px 50px 100px;
        button{
            border-radius: 10px;
        }
    }
</style>
